import React from 'react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import CreateProviderPayment from '../../../components/ProviderPayment/CreateProviderPayment.js';

export default function ProviderPayments() {
  return (
    <AdminPageShell title="Pagos a proveedores">
      <CreateProviderPayment />
    </AdminPageShell>
  );
}
